'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash.throttle');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Accordion = function () {
  function Accordion(el, trigger, body) {
    (0, _classCallCheck3.default)(this, Accordion);


    if (el === null && trigger === null && body === null) return;

    this.el = el;
    this.trigger = el.querySelector(trigger);
    this.contentBody = el.querySelector(body);
    this.openClass = 'is-open';
    this.state = {
      isOpen: false,
      openHeight: null,
      closeHeight: 0
    };

    this.init();
  }

  (0, _createClass3.default)(Accordion, [{
    key: 'addEvents',
    value: function addEvents() {
      this.getOpenHeight();
      this.trigger.addEventListener('click', this.toggleHeight.bind(this));
      window.addEventListener('resize', (0, _lodash2.default)(this.getOpenHeight).bind(this), 400);
    }
  }, {
    key: 'getOpenHeight',
    value: function getOpenHeight() {
      return this.state.openHeight = this.contentBody.scrollHeight;
    }
  }, {
    key: 'open',
    value: function open() {
      this.state.isOpen = true;
      this.trigger.classList.add(this.openClass);
      this.contentBody.style.height = this.state.openHeight + 'px';
    }
  }, {
    key: 'close',
    value: function close() {
      this.state.isOpen = false;
      this.trigger.classList.remove(this.openClass);
      this.contentBody.style.height = '0px';
    }
  }, {
    key: 'toggleHeight',
    value: function toggleHeight(el) {
      el.preventDefault();
      return this.state.isOpen ? this.close() : this.open();
    }
  }, {
    key: 'init',
    value: function init() {
      this.addEvents();
    }
  }]);
  return Accordion;
}();

exports.default = Accordion;